var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"replay"},on:{"dragover":function($event){$event.preventDefault();return _vm.setDropEffect($event)},"drop":function($event){$event.preventDefault();return _vm.handleFileUpload($event)}}},[_c('Viewport')],1)}
var staticRenderFns = []

export { render, staticRenderFns }